import { render, staticRenderFns } from "./CumulativeGrowth.vue?vue&type=template&id=d4c6670c&"
import script from "./CumulativeGrowth.vue?vue&type=script&lang=js&"
export * from "./CumulativeGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports